<template>
  <div class="app-layout">
    <!-- 头部 -->
    <header>
      <top></top>
    </header>
    <!-- 内容 -->
    <main>
      <div class="container">
        <nuxt />
        <LoginModal></LoginModal>
      </div>
    </main>
    <!-- 底部 -->
    <footer>
      <footerIndex></footerIndex>
    </footer>
  </div>
</template>

<script>
import top from '@/components/top.vue'
import footerIndex from '@/components/footer.vue'
import LoginModal from '@/components/login.vue'
export default {
  components: { top, footerIndex, LoginModal },
  mounted() {
    // 初始化时检查登录状态
    this.$store.dispatch('initAuth')
  },
  created () {
    this.autoLogin()
  },
  methods: {
    autoLogin () {
      let str = ''
      if (process.client) {
        str = location.href
      }
      if (str.indexOf('?') != -1) {
        // 获取地址栏参数
        let num = str.indexOf("?")
        str = str.substr(num + 1)
        let arr = str.split("&")
        for(var i = 0; i < arr.length; i++) {
          num = arr[i].indexOf("=")
          if (num > 0) {
            if (arr[i].substring(0, num) === 'secret_token' && process.browser) {
              let secret_token = arr[i].substr(num + 1)
              this.login(secret_token)
            }
          }
        }
      }
    },
    login (token) {
      this.$store.dispatch('autoLogin', token)
    }
  }
}
</script>

<style scoped>
::v-deep .swiper-pagination-bullet{
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background:#fff;
  box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.3);
  opacity: 1;
  transition: all 0.3s ease;
  cursor: pointer;
}

::v-deep .swiper-pagination-bullet-active{
  background: #fff;
  transform: scale(1.2);
  box-shadow: 0 0 0 4px #198052;
}
/* 悬停效果 */
::v-deep .swiper-pagination-bullet:hover {
  background: rgba(255, 255, 255, 0.5);
}
</style>